import { Box, Button, Tooltip } from "@mui/material";
import { Report, CancelPresentation } from "@mui/icons-material";
import { Order, OrderOptimizedListResponse } from "../utils/types";
import { useTranslation } from "../../../hooks/useTranslation";
import { useOrderPurchase } from "../../../hooks/useOrderPurchase";

type Props = {
  order: Order | OrderOptimizedListResponse;
};

export const OrderAction = ({ order }: Props) => {
  const { translate } = useTranslation("pages.orders");
  const { handlePurchase } = useOrderPurchase(order);

  const isWaitingForAddress = order.orderStatus === "WAITING_FOR_ADDRESS";

  const hasCancellationRequest =
    order.deliveryOrder?.cancellationRequestedByBuyer;

  return (
    <Box display="flex" alignItems="center" gap={1} height="100%">
      {/* Address missing */}
      {isWaitingForAddress && (
        <Tooltip title={translate("list.fields.noAddress")}>
          <Report color="error" fontSize="small" />
        </Tooltip>
      )}

      {/* Cancellation request warning */}
      {hasCancellationRequest && (
        <Tooltip title={translate("detail.cancellationRequestedTitle")}>
          <CancelPresentation color="error" />
        </Tooltip>
      )}

      <Button
        variant="contained"
        size="small"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handlePurchase();
        }}
        disabled={isWaitingForAddress}
        color={hasCancellationRequest ? "error" : "primary"}
      >
        {translate("list.fields.purchase")}
      </Button>
    </Box>
  );
};
